// extracted by mini-css-extract-plugin
module.exports = {"wavePosition":"wave_wavePosition__15Ktl","moveBottom":"wave_moveBottom__2cSNE","parallax":"wave_parallax__3181k","move-forever":"wave_move-forever__mKt8Z"};